import { Exclude } from "class-transformer";
import CreateStoreDto from "./CreateStoreDto";

@Exclude()
class UpdateStoreDto extends CreateStoreDto {}

export default UpdateStoreDto;
